// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section4 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section four' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>L'âge des chiens</h2>
          <div className='txt'>
            <p>
              Les données relatives à l'âge des chiens au moment de leur mort ne sont malheureusement pas accessibles au public. Mais il est généralement admis que ces animaux vivent en moyenne entre 10 et 15 ans. Les grands spécimens ont une espérance de vie nettement plus courte que les petits, c’est peut-être aussi une raison supplémentaire pour laquelle les petits chiens sont préférés aux grands.
            </p>
            <p>
              En Suisse, seuls 4% des chiens ont actuellement plus de 15 ans. La plupart d'entre eux ont entre 1 et 3 ans. À partir de 10 ans, le nombre d'animaux diminue fortement. Seul un quart est plus âgé. Un chien de 10 ans aurait environ une soixantaine d'années en tant qu'être humain.
            </p>
          </div>
          <div className="chart">
            <AutofitIFrame
              src={'https://datawrapper.dwcdn.net/zYXNc/1/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
            />
          </div>        
          <div className='txt'>
            <p>
              L'espérance de vie des chiens n'est pas seulement déterminée par la taille ou la race, mais aussi par les conditions de vie: l'alimentation et les soins, l'environnement et la quantité d'exercice. Ainsi, les chiens de campagne vivent généralement un peu plus longtemps que leurs congénères vivant en ville.
            </p>
          </div>
      </div>
    </div>
  }
}
